
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { Post } from "@/components/post/Post";
import { useAuth } from "@/contexts/AuthContext";

const PostDetail = () => {
  const { id } = useParams();
  const { user } = useAuth();

  const { data: post, isLoading } = useQuery({
    queryKey: ['post', id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('posts')
        .select(`
          *,
          profiles (
            username,
            full_name,
            avatar_url,
            is_pro
          ),
          comments (
            id,
            content,
            created_at,
            user_id,
            parent_id,
            profiles (
              username,
              avatar_url
            )
          )
        `)
        .eq('id', id)
        .single();

      if (error) throw error;
      return data;
    },
    enabled: !!id
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-flux-cyan"></div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-white">Post not found</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto py-6">
      <Post post={post} isDetailView currentUserId={user?.id} />
    </div>
  );
};

export default PostDetail;
